import ReplacementCost from './ReplacementCost'

export default ReplacementCost